import {
  Modal,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';
import { Circle, Warning } from '@mui/icons-material';
import { CustomLoadingButton } from 'components/Buttons/CustomLoadingButton/CustomLoadingButton';
import { useTranslation } from 'react-i18next';

export const SetTodayPlanConfirmationModal = ({
  open,
  inactiveAssets,
  onClose,
  onConfirm,
}: {
  open: boolean;
  inactiveAssets: string[];
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
          return;
        }
        onClose();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        sx={{
          p: 4,
          width: 400,
          maxWidth: '90%',
          mx: 'auto',
          borderRadius: 3,
          outline: 'none',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Warning color="warning" sx={{ mr: 1 }} />
          <Typography variant="h6">{t('confirm_plan_activation')}</Typography>
        </Box>

        {inactiveAssets.length > 0 ? (
          <>
            <Typography sx={{ mb: 1 }}>
              {t('the_following_assets_are')} <b>{t('out_of_service')}</b>:
            </Typography>
            <List dense>
              {inactiveAssets.map((asset) => (
                <ListItem
                  key={asset}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Circle
                    sx={{
                      fontSize: '8px',
                    }}
                  />{' '}
                  <ListItemText primary={asset} />
                </ListItem>
              ))}
            </List>
            <Typography sx={{ mt: 1 }}>
              {t('do_you_still_want_to_apply_this_plan')}
            </Typography>
          </>
        ) : (
          <Typography>
            {`Do you want to set this plan as today's active plan?`}
          </Typography>
        )}

        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}
        >
          <CustomLoadingButton onClick={onClose} color="error">
            {t('cancel')}
          </CustomLoadingButton>
          <CustomLoadingButton color="success" onClick={onConfirm}>
            {t('apply')}
          </CustomLoadingButton>
        </Box>
      </Paper>
    </Modal>
  );
};
